import { render, staticRenderFns } from "./err-block.vue?vue&type=template&id=282cb778&scoped=true&"
import script from "./err-block.vue?vue&type=script&lang=ts&"
export * from "./err-block.vue?vue&type=script&lang=ts&"
import style0 from "./err-block.vue?vue&type=style&index=0&id=282cb778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cb778",
  null
  
)

export default component.exports